import LcmDirectDeposit from 'features/advance/screens//registration/LcmDirectDeposit/LcmDirectDeposit';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function LcmDirectDepositPage() {
  return (
    <PinwheelContextProvider>
      <LcmDirectDeposit />
    </PinwheelContextProvider>
  );
}
